import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import {
  IGenerateMasterPromptPayload,
  IGenerateMasterPromptResult,
} from "../types";
import { readApiError } from "./readApiError";

export function useGenerateMasterPrompt(
  onSuccess?: (analysis: string) => void
) {
  const generateMasterPrompt = useCallback(
    (payload: IGenerateMasterPromptPayload) =>
      AiWorkspaceService.generateMasterPrompt(payload)
        .then((res) => {
          if (!res.data?.analysis) {
            ToastService.error(
              res.data?.error || "Could not generate a prompt"
            );
            throw new Error("Could not generate a prompt");
          }
          return res;
        })
        .catch(async (err) => {
          if (
            err instanceof Error &&
            err.message === "Could not generate a prompt"
          ) {
            throw err;
          }
          ToastService.error(
            await readApiError(err, "Could not generate a prompt")
          );
          throw err;
        }),
    []
  );

  const { mutate: generate, isLoading: isGenerating } = useMutation<
    IGenerateMasterPromptPayload,
    BackednResponse<IGenerateMasterPromptResult>
  >({
    mutationFn: generateMasterPrompt,
    options: { skipInvalidation: true },
    onSuccess: (_client, data) => {
      if (data?.data?.analysis) onSuccess?.(data.data.analysis);
    },
  });

  return { generate, isGenerating };
}
